export function setupLiveKitRoom() {
  const className = 'lk-room-container';
  return { className };
}
